export default angular.module( 'app-checkout', ['ngRoute','ngCookies']);
export const AppMarket = angular.module( 'app-market', [] );
